import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "\n      d-flex\n      flex-column flex-column-fluid\n      bgi-position-y-bottom\n      position-x-center\n      bgi-no-repeat bgi-size-contain bgi-attachment-fixed\n    ",
  style: {"background-image":"url('media/illustrations/progress-hd.png')","background-color":"#597dfe !important"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/logos/logo.png",
    class: "h-45px"
  })
], -1)
const _hoisted_4 = { class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = { class: "mb-10 text-center" }
const _hoisted_6 = { class: "text-dark mb-3" }
const _hoisted_7 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_8 = { class: "row fv-row mb-7" }
const _hoisted_9 = { class: "col-xl-6" }
const _hoisted_10 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "col-xl-6" }
const _hoisted_14 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_18 = { class: "mb-1" }
const _hoisted_19 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_20 = { class: "position-relative mb-3" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "fv-row mb-5" }
const _hoisted_24 = { class: "form-label fw-bolder text-dark fs-6" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "fv-row mt-9 mb-10" }
const _hoisted_28 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_29 = {
  class: "\n                  form-check-label\n                  fw-bold\n                  text-gray-700\n                  fs-6\n                  d-inline-block\n                ",
  style: {"max-width":"510px"}
}
const _hoisted_30 = {
  href: "#",
  class: "ms-1 link-primary"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_36 = { class: "indicator-label" }
const _hoisted_37 = { class: "indicator-progress" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_39 = {
  class: "w-175px",
  style: {"display":"flex","align-content":"space-between","margin-left":"40.5%"}
}
const _hoisted_40 = { class: "menu-item" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg"
  })
], -1)
const _hoisted_42 = { class: "menu-item" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/spain.svg"
  })
], -1)
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center flex-column-auto p-10\"><div class=\"d-flex align-items-center fw-bold fs-6\"><a href=\"#\" class=\"text-muted text-hover-primary px-2\">About</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact</a><a href=\"#\" class=\"text-muted text-hover-primary px-2\">Contact Us</a></div></div>", 1)
const _hoisted_45 = {
  key: 1,
  class: "\n      d-flex\n      flex-column flex-column-fluid\n      bgi-position-y-bottom\n      position-x-center\n      bgi-no-repeat bgi-size-contain bgi-attachment-fixed\n    ",
  style: {"background-image":"url('media/illustrations/progress-hd.png')","background-color":"#597dfe !important"}
}
const _hoisted_46 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_47 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/logos/logo.png",
    class: "h-45px"
  })
], -1)
const _hoisted_48 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_49 = { class: "fv-row mb-10" }
const _hoisted_50 = { class: "form-label fw-bolder text-gray-900 fs-6" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "fv-row mb-10" }
const _hoisted_54 = { class: "form-label fw-bolder text-gray-900 fs-6" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_58 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder ms-4"
}
const _hoisted_59 = { class: "indicator-label" }
const _hoisted_60 = { class: "indicator-progress" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_62 = {
  class: "w-175px",
  style: {"display":"flex","align-content":"space-between","margin-left":"40.5%"}
}
const _hoisted_63 = { class: "menu-item" }
const _hoisted_64 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg"
  })
], -1)
const _hoisted_65 = { class: "menu-item" }
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "rounded-1",
    src: "/media/flags/spain.svg"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")

  return (_ctx.isNew == '1')
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Form, {
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              novalidate: "novalidate",
              onSubmit: _ctx.saveNewPassword,
              id: "kt_login_signup_form",
              "validation-schema": _ctx.registration
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("h1", _hoisted_6, _toDisplayString(_ctx.translate("invitationMessages.editAccount")), 1),
                  _createVNode("div", _hoisted_7, _toDisplayString(_ctx.translate("invitationMessages.changeData")), 1)
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.translate("name")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid",
                      type: "text",
                      placeholder: "",
                      name: "name",
                      modelValue: _ctx.user.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.name = $event)),
                      autocomplete: "off"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, [
                        _createVNode(_component_ErrorMessage, { name: "name" })
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _createVNode("label", _hoisted_14, _toDisplayString(_ctx.translate("lastName")), 1),
                    _createVNode(_component_Field, {
                      class: "form-control form-control-lg form-control-solid",
                      type: "text",
                      placeholder: "",
                      name: "surname",
                      modelValue: _ctx.user.lastName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.lastName = $event)),
                      autocomplete: "off"
                    }, null, 8, ["modelValue"]),
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "surname" })
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("label", _hoisted_19, _toDisplayString(_ctx.translate("password")), 1),
                    _createVNode("div", _hoisted_20, [
                      _createVNode(_component_Field, {
                        class: "form-control form-control-lg form-control-solid",
                        type: "password",
                        placeholder: "",
                        name: "password",
                        autocomplete: "off"
                      }),
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, [
                          _createVNode(_component_ErrorMessage, { name: "password" })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _createVNode("label", _hoisted_24, _toDisplayString(_ctx.translate("passwordConfirm")), 1),
                  _createVNode(_component_Field, {
                    class: "form-control form-control-lg form-control-solid",
                    type: "password",
                    placeholder: "",
                    name: "cpassword",
                    autocomplete: "off"
                  }),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "cpassword" })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("label", _hoisted_28, [
                    _createVNode(_component_Field, {
                      class: "form-check-input",
                      type: "checkbox",
                      name: "toc",
                      value: "1"
                    }),
                    _createVNode("span", _hoisted_29, [
                      _createTextVNode(_toDisplayString(_ctx.translate("acceptedOur")) + " ", 1),
                      _createVNode("a", _hoisted_30, _toDisplayString(_ctx.translate("termAndCondition")), 1),
                      _hoisted_31
                    ])
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _createVNode("div", _hoisted_33, [
                      _createVNode(_component_ErrorMessage, { name: "toc" })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_34, [
                  _createVNode("button", _hoisted_35, [
                    _createVNode("span", _hoisted_36, _toDisplayString(_ctx.translate("send")), 1),
                    _createVNode("span", _hoisted_37, [
                      _createTextVNode(_toDisplayString(_ctx.translate("pleaseWait")) + " ", 1),
                      _hoisted_38
                    ])
                  ], 512)
                ]),
                _createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _createVNode("a", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLang('en'))),
                      href: "#",
                      class: ["menu-link d-flex", { active: _ctx.currentLanguage('en') }]
                    }, [
                      _hoisted_41
                    ], 2)
                  ]),
                  _createVNode("div", _hoisted_42, [
                    _createVNode("a", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLang('es'))),
                      href: "#",
                      class: ["menu-link d-flex", { active: _ctx.currentLanguage('es') }]
                    }, [
                      _hoisted_43
                    ], 2)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]),
        _hoisted_44
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _hoisted_47,
          _createVNode("div", _hoisted_48, [
            _createVNode(_component_Form, {
              class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
              onSubmit: _ctx.saveNewPassword,
              id: "kt_new-password_form",
              "validation-schema": _ctx.ChangePassword
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_49, [
                  _createVNode("label", _hoisted_50, _toDisplayString(_ctx.translate("password")), 1),
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "password",
                    name: "password",
                    placeholder: _ctx.translate('enterPassword')
                  }, null, 8, ["placeholder"]),
                  _createVNode("div", _hoisted_51, [
                    _createVNode("div", _hoisted_52, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("label", _hoisted_54, _toDisplayString(_ctx.translate("passwordConfirmation")), 1),
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "password",
                    placeholder: _ctx.translate('passwordConfirmationDescription'),
                    name: "passwordConfirmation",
                    autocomplete: "off"
                  }, null, 8, ["placeholder"]),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("div", _hoisted_56, [
                      _createVNode(_component_ErrorMessage, { name: "passwordConfirmation" })
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_57, [
                  _createVNode("button", _hoisted_58, [
                    _createVNode("span", _hoisted_59, _toDisplayString(_ctx.translate("save")), 1),
                    _createVNode("span", _hoisted_60, [
                      _createTextVNode(_toDisplayString(_ctx.translate("pleaseWait")) + " ", 1),
                      _hoisted_61
                    ])
                  ], 512)
                ]),
                _createVNode("div", _hoisted_62, [
                  _createVNode("div", _hoisted_63, [
                    _createVNode("a", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLang('en'))),
                      href: "#",
                      class: ["menu-link d-flex", { active: _ctx.currentLanguage('en') }]
                    }, [
                      _hoisted_64
                    ], 2)
                  ]),
                  _createVNode("div", _hoisted_65, [
                    _createVNode("a", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setLang('es'))),
                      href: "#",
                      class: ["menu-link d-flex", { active: _ctx.currentLanguage('es') }]
                    }, [
                      _hoisted_66
                    ], 2)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ])
      ]))
}